<template>
  <div class="info-tile" @click="throttledOnClick">
    <div class="info-tile-content c:row-between-center">
      <div class="info-tile-label">{{ label }}</div>
      <div class="info-tile-value"><slot /></div>
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    label: String,
    value: {
      type: String,
      default: "",
    },
  },
  created() {
    this.throttledOnClick = throttle(this.onClick, 500);
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped>
.info-tile {
  --border-color: #e4e4e4;

  width: 100vw;
  height: 48/20rem;
  background-color: #fff;
  padding: 0 18/20rem;

  &:last-child {
    --border-color: transparent;
  }

  &-content {
    gap: 6/20rem;

    box-sizing: border-box;
    width: 100%;
    height: 100%;

    border-bottom: solid 1px var(--border-color);
  }

  &-label {
    flex: 1;
    width: 0;
    height: 18/20rem;
    line-height: 18/20rem;
    text-align: left;
    font-size: 14/20rem;
    font-weight: 500;
    letter-spacing: 0;
    color: #000000;
  }

  &-value {
    min-width: 50%;
    height: 18/20rem;
    line-height: 18/20rem;
    text-align: right;
    font-size: 12/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #7d7d7d;
  }
}
</style>
